import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AppState } from 'src/app/app.state';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent {
  showFooter: boolean = false;
  onDestroyNotifier$ = new Subject();

  constructor(
    public appState: AppState,
  ) { }

  ngOnInit(): void {

    this.appState.companyInfo$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res && res.alias == 'homerise') {
          this.showFooter = true;
        }
      });
  };

}
